export { default } from './svg/upload.svg';
